import styled from "styled-components";

export default styled.div`
    position: relative;
    z-index: 2;
    padding: 5rem 5rem;
    display: flex;
    justify-content: flex-start;
    align-content:  flex-start;
    align-items: flex-start;
    flex-direction: row;
    box-sizing: border-box;
    transform-origin: 50% 0%;
    min-height: 100vh;
    
    transform: 
        rotateX(0deg)
        rotateY(5deg)
        rotateZ(-2deg)
        skewX(-1deg)
        skewy(2deg)
        perspective(140px)
        scale(1.1, 1.1);

    @media screen and (max-width: 1260px) {
        flex-direction: column;
        padding: 1rem 4rem 4rem ;
        padding-left: 4rem;
        justify-content: flex-start;
        width: 100%;
    }

    @media screen and (max-width: 920px) {
        padding: 3rem;
    }

    @media screen and (max-width: 600px) {
        padding: 4rem 2rem 30vh 2rem;
        
    }
  
    @media screen and (max-width: 390px) {
        padding: 4rem 2rem 15vh 2rem;
    }
        
    @media screen and (max-height: 1160px) {
        transform: scale(0.9);
    }

    @media screen and (max-width: 920px) {
        transform: scale(0.9);
    }

    @media screen and (max-height: 960px) {
        transform: scale(0.8);
    }

    @media screen and (max-width: 740px) {
        transform: scale(0.8);
    }

    @media screen and (max-width: 390px) {
        transform: scale(0.7);
    }

    @media screen and (max-height: 800px) {
        transform: scale(0.7);
    }
`